import moment from 'moment'
import React from 'react'

import {
  Flex,
  IconButton,
  Link,
  Text,
  Tooltip,
  UserAvatar 
} from '@driftt/dds'
import { faTrash } from '@driftt/dds.icons/dist/light/faTrash'
import {
  Input,
  Span,
  ToolTip 
} from '@driftt/tide-core'
import { resolveContactName } from 'utils/contact'

const selectAll = (bulkSelect, isChecked) => {
  return (
    <Input type="checkbox" checked={isChecked}
      onChange={bulkSelect} />
  )
}

const lastUpdatedCell = () => (
  <ToolTip tethered flow="down"
    component={<div className="contacts-table--tooltip-content">Last time the system updated<br /> the contact record</div>}>
    <Span>Last updated</Span>
  </ToolTip>
)

export const Columns = (bulkSelect, isChecked, onChange) => ([
  {
    label: selectAll(bulkSelect, isChecked),
    sortable: false,
    width: '20px'
  },
  {
    label: 'Contact',
    value: 'name',
    sortable: true,
    onClick: onChange,
    width: '300px'
  },
  {
    label: 'Email',
    sortable: true,
    value: 'email',
    onClick: onChange,
    width: '200px'
  },
  {
    label: 'Lead stage',
    sortable: true,
    value: '_classification',
    onClick: onChange,
    width: '175px'
  },
  {
    label: lastUpdatedCell(),
    value: 'last_contacted',
    sortable: true,
    onClick: onChange,
    width: '150px'
  },
  {
    label: '',
    sortable: false,
    width: '71px'
  },
])


export const getColumns = (onDelete) => [{
  header: 'Contact',
  value: 'name',
  cell: (contact) => {
    return(
      <Flex
        alignItems='center'
        justifyContent='flex-start'
        css={{ cursor: 'pointer' }}
      >
        <UserAvatar size="small" name={resolveContactName(contact, true)} />
        <Link 
          href={`/contacts/details/${contact.id}`} 
          rel="noopener noreferrer"
          target="_blank" 
          underline={false}
          css={{ '&:hover': { textDecoration: 'none' } }}
        >
          <Text 
            variant="body" 
            isPrivate={true}
            css={{
              color: "$blue7",
              maxWidth: "300px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis", 
            }}
          >
            {resolveContactName(contact, true)}
          </Text>
        </Link>
      </Flex>
    )
  },
  size: 300
},
{
  header: 'Email',
  value: 'email',
  cell: (contact) => {
    return(
      <Tooltip side="top" content={contact.email ? contact.email : 'Unknown'}
        css={{
          maxWidth: 'none',
          whiteSpace: 'nowrap' 
        }}>
        <Text isPrivate={true} css={{
          maxWidth: "200px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}>
          {contact.email ? contact.email : 'Unknown'}
        </Text>
      </Tooltip>
    )
  },
  size: 200
},
{
  header: 'Lead stage',
  value: '_classification',
  cell: ({ attributes: { _classification } }) => <Text variant="body"> {_classification ? _classification : "-"}</Text>,
  size: 175
},
{
  header: 'Last updated',
  value: 'last_contacted',
  cell: ({ attributes: { last_contacted } }) => (
    <Text variant="body">{last_contacted ? moment(last_contacted).fromNow() : "-"}</Text>
  ),
  size: 150
},
{
  id: 'actions',
  header: '',
  cell: (contact) => {
    return(
      <Flex alignItems="center" justifyContent="center">
        <IconButton
          icon={faTrash}
          title="Delete contact"
          onClick={() => onDelete(contact.id)}
        />
      </Flex>
    )
  },
  size: 71
},
]
